
<template>
  <form class="product-form side-padded-mobile" @submit.prevent="() => {}" @click="toReviews" method="post" action="/cart/add" accept-charset="UTF-8" enctype="multipart/form-data" novalidate="novalidate" data-product-form="">
    <div class="product-form__left">
      <div class="product-form__desktop-top">
        <product-form-top-mobile class="product-form__top" v-bind="$props" :value="variant" :afterpay="afterpay"></product-form-top-mobile>
      </div>
      <div class="product-form__options-container" v-if="filteredVariants.length">
        <product-pseudo-variants :pseudo-variants="pseudoVariants" :product="product"></product-pseudo-variants>
        <div class="product-form__variant-option-sets">
          <product-size-guide :content="customFields.size_chart" v-if="customFields.size_chart"></product-size-guide>
          <div class="product-form__variant-option-set option-set margin-top" :key="optIndex" v-for="(option, optIndex) in product.options">
            <p class="option-set__top">
              <span class="option-set__label">{{ option }}</span>
              <span class="option-set__value"> {{ sizeName(optIndex) }}</span>
            </p>
            <template v-for="_variant of uniqBy(filteredVariants, `option${optIndex + 1}`)">
              <input :key="`${_variant.id}${optIndex}`" class="product-form__option-button-input" type="radio" tabindex="0" :name="option" :value="_variant[`option${optIndex + 1}`]" :checked="_variant[`option${optIndex + 1}`] === selectedOptions[optIndex]" @change="variantChange(optIndex, _variant[`option${optIndex + 1}`])" :id="`${option}-${_variant[`option${optIndex + 1}`]}`"/>
              <label :key="_variant.id" :class="!_variant.available && 'disabled'" class="body-sm" tabindex="0" :for="`${option}-${_variant[`option${optIndex + 1}`]}`" v-tooltip.top="getVTooltipConfig(_variant)">{{ _variant[`option${optIndex + 1}`] }}</label>
            </template>
          </div>
        </div>
      </div>
      <div class="product-form__mobile">
        <div class="flex-row space-between align-center nowrap" v-if="!is3rdPartyProduct(product) && !customFields.hide_atc">
          <div class="product-form__quantity-wrapper margin-top">
            <label class="button-text" for="quantity">qty</label>
            <quantity-selector class="product-form__quantity" v-model="quantity" :isValidQuantity="(num) => num > 0" @valid="(isValid) => validQuantity = isValid" :class="{'product-form__quantity--error': !validQuantity}" :forceValidQuantity="false"></quantity-selector>
          </div>
        </div>
        <v-button class="margin-top pdp__atc product-form__atc button--full button button--primary" v-if="isHiddenProduct(product) && !customFields.hide_atc" disabled="disabled">Add To Cart</v-button>
        <a class="button pdp__atc product-form__atc product-form__atc--full button--full button button--primary" v-else-if="is3rdPartyProduct(product) && !customFields.hide_atc" :href="customFields.third_party_atc_url" target="_blank">
          <span class="button__content">{{ customFields.third_party_atc_text || "Add To Cart" }}</span>
        </a>
        <async-button class="margin-top pdp__atc product-form__atc button--full button button--primary" v-else-if="!customFields.hide_atc" :disabled="!variant || !variant.available || !validQuantity" :promise="addToCartPromise" @click.stop="addToCart" :title="atcTitle" type="submit" name="add" data-add-to-cart="data-add-to-cart">{{ atcVerbiage }}</async-button>
        <div class="body-md u-hidden-tablet-up client-generated pftm__summary" v-if="customFields.d2_short_description">
          <span v-html="customFields.d2_short_description"></span>
        </div>
        <slot></slot>
        <div class="product-form__optional-messaging client-generated border-bottom" v-if="customFields.optional_message" v-html="customFields.optional_message"></div>
        <div class="product-form__feature-icons" v-if="customFields.product_icon_set">
          <div class="product-form__icon-set" :key="index" v-for="index in (customFields.product_icon_set || '').split(',')">
            <div class="product-form__icon-set-wrap">
              <img v-if="iconSetCollection[index].image" :src="iconSetCollection[index].image" alt="value proposition" aria-role="presentation"/>
              <span class="body-xs">{{ iconSetCollection[index].firstLine || '' }}</span>
              <span class="body-xs">{{ iconSetCollection[index].secondLine || '' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex'
import uniqBy from 'lodash/uniqBy'
import uniq from 'lodash/uniq'
import defaults from 'lodash/defaults'
import { truncateEllipsis, getProductUrl, getProductSocialLinks, generateId, imageSize, imageCrop, isHiddenProduct, is3rdPartyProduct } from '@/scripts/helpers/util'
import { scrollToId } from '@/scripts/helpers/scroll'
import QuantitySelector from '@/scripts/components/basic/Quantity.vue'
import AsyncButton from '@/scripts/components/buttons/AsyncButton.vue'
import VButton from '@/scripts/components/buttons/VButton.vue'
import ProductPseudoVariants from './ProductPseudoVariants.vue'
import Icon from '@/scripts/components/basic/Icon.vue'
import VLink from '@/scripts/components/buttons/VLink.vue'
import ProductFormTopMobile from './ProductFormTopMobile.vue'
import ProductSizeGuide from './ProductSizeGuide.vue'
import lowercase from 'lodash/lowerCase'
import { SwymWishlist } from '@/scripts/helpers/swym-wishlist'

export default {
  name: 'ProductForm',
  components: {
    QuantitySelector,
    AsyncButton,
    ProductPseudoVariants,
    Icon,
    VLink,
    VButton,
    ProductFormTopMobile,
    ProductSizeGuide
  },
  model: {
    prop: 'variant'
  },
  props: {
    collection: Object,
    product: Object,
    customFields: Object,
    settings: Object,
    variant: Object,
    magnetProduct: Object,
    selectedMagnetVariant: Object,
    prices: Object,
    displayVendor: Boolean,
    pseudoVariants: Array,
    afterpay: String
  },
  data () {
    return {
      selectedOptions: [this.variant.option1, this.variant.option2, this.variant.option3],
      quantity: 1,
      addToCartPromise: null,
      reviewSource: window.bvaccel && window.bvaccel.reviewSource,
      validQuantity: true
    }
  },
  filters: {
    truncate: truncateEllipsis(250)
  },
  computed: {
    atcTitle () {
      if (this.magnetProduct && !this.selectedMagnetVariant) {
        return 'Please select a magnet'
      }
      return ''
    },
    subtitle () {
      const { subtitlePretext } = this.settings
      let cfVendor = this.customFields.product_vendor

      if (this.variant && this.variant.cf_vendor) { cfVendor = this.variant.cf_vendor }

      if (subtitlePretext && cfVendor) { return subtitlePretext + ' ' + cfVendor } else if (cfVendor) { return cfVendor }
      return ''
    },
    iconSetCollection (index) {
      if (!this.customFields.product_icon_set) return []
      const images = (this.customFields.icon_image || '').split('|###|')
      const firstLines = (this.customFields.first_line_of_text || '').split('|###|')
      const secondLines = (this.customFields.second_line_of_text || '').split('|###|')

      return this.customFields.product_icon_set
        .split(',')
        .map(index => ({
          image: images[index],
          firstLine: firstLines[index],
          secondLine: secondLines[index]
        }))
    },
    /** @returns {Boolean} */
    hasColorVariants () {
      return this.product.options.some(opt => /color|pattern|design/i.test(opt))
    },
    /** @returns {Number} */
    colorIndex () {
      if (!this.hasColorVariants) return 0

      return this.product.options.reduce((acc, opt, i) => /color|pattern|design/i.test(opt) ? i : acc, 0)
    },
    /** @returns {Array<Object>} */
    filteredVariants () {
      return this.product.variants.filter(v => v.title.toLowerCase() !== 'default title')
    },
    /** @returns {Object} {swatchType: [variants with that swatch type]} */
    filteredColorVariants () {
      if (!this.hasColorVariants) return []

      const uniqueColorVariants = uniqBy(this.product.variants, `option${this.colorIndex + 1}`)
      const swatchTypeDefault = this.product.options[this.colorIndex]
      const separatedBySwatchType = uniqueColorVariants.reduce((acc, cur) => {
        const swatchType = cur.swatch_type || swatchTypeDefault
        acc[swatchType] = acc[swatchType] instanceof Array ? [...acc[swatchType], cur] : [cur]
        return acc
      }, {})

      return separatedBySwatchType
    },
    shareLinks () {
      return getProductSocialLinks(window.bvaccel.shop.domain, this.collection, this.product, this.variant)
    },
    atcVerbiage () {
      if (!this.variant) {
        return 'Unavailable'
      } else if (!this.variant.available) {
        return 'Out of Stock'
      } else if (!this.validQuantity) {
        return 'Enter Quantity'
      }

      return 'Add to Cart'
    },
    upsellData () {
      const cf = this.customFields
      const { settings } = this

      return defaults(
        {
          img: cf.upsell_image,
          heading: cf.upsell_heading,
          copy: cf.upsell_copy,
          cta_copy: cf.upsell_cta_copy,
          cta_url: cf.upsell_cta_url
        },
        {
          img: settings.upsellImg,
          heading: settings.upsellHeading,
          copy: settings.upsellCopy,
          cta_copy: settings.upsellCtaCopy,
          cta_url: settings.upsellCtaUrl
        }
      )
    },
    onSale () {
      return this.variant && this.variant.price < this.variant.compare_at_price
    }
  },
  methods: {
    imageSize,
    imageCrop,
    uniqBy,
    lowercase,
    isHiddenProduct,
    is3rdPartyProduct,
    openRegistry () {
      const target = document.querySelector('.myregistry')
      if (window.currentMrWidgetObj && target) { target.click() }
    },
    sizeName (index) {
      let size = this.selectedOptions[index];
      switch(size) {
        case 'OS':
          size = 'One Size'
          break;
        case 'O/S':
          size = 'One Size'
          break;
        case 'XXS':
          size = 'XX-Small'
          break;
        case 'XS':
          size = 'X-Small'
          break;
        case 'S':
          size = 'Small'
          break;
        case 'M':
          size = 'Medium'
          break;
        case 'L':
          size = 'Large'
          break;
        case 'XL':
          size = 'X-Large'
          break;
        case 'XXL':
          size = 'XX-Large'
          break;
        default:
          size = size
      }
      return size;
    },
    /**
       * Get a v-tooltip configuration object
       * @param {Object} variant
       * @returns {Object}
       * */
    getVTooltipConfig (variant) {
      return {
        position: 'top',
        content: variant.d2_variant_hover_text,
        trigger: this.$mq === 'mobile' ? 'manual' : 'hover', // don't show the tooltip on mobile (iOS extra click)
        classes: this.$mq === 'mobile' ? 'u-hidden' : ''
      }
    },
    /** @desc scroll to reviews section when reviews badge is clicked */
    toReviews (e) {
      if (e.target.matches('.spr-badge, .spr-badge *')) {
        scrollToId(e, '#pdp-reviews')
      }
    },
    addToCart () {
      let items = []
      const _kitId = generateId()

      if (this.selectedMagnetVariant) {
        items = [
          { id: this.variant.id, quantity: this.quantity },
          { id: this.selectedMagnetVariant.id, quantity: this.quantity }
        ].map(obj => Object.assign(obj, { properties: { _kitId } }))
      } else {
        items.push({ id: this.variant.id, quantity: this.quantity })
      }

      this.addToCartPromise = this.$store.dispatch('cart/addItems', items)
        .then(() => window.setTimeout(() => this.$store.dispatch('cart/afterAddToCart'), 1000))
        .catch(error => this.$store.dispatch('toast/send', { text: error, type: 'error' }))
      return this.addToCartPromise
    },
    scrollTo (...args) {
      scrollToId(...args)

      if (!window.bvaccel.toggleProductDetailsaccordion.active) { window.bvaccel.toggleProductDetailsaccordion() }
    },
    colorChange (variant) {
      this.variantChange(this.colorIndex, variant[`option${this.colorIndex + 1}`])
    },
    variantChange (optionIndex, optionValue) {
      this.$set(this.selectedOptions, optionIndex, optionValue)

      const [newVariant] = this.product.variants
        .filter(v => v.option1 === this.selectedOptions[0])
        .filter(v => v.option2 === this.selectedOptions[1])
        .filter(v => v.option3 === this.selectedOptions[2])

      this.$emit('input', newVariant)
    }
  },
  watch: {
    variant (newValue, oldValue) {
      if (!newValue || !oldValue) return

      if (newValue.id !== oldValue.id) {
        let url = new URL(window.location.href);
        let params = new URLSearchParams(url.search.slice(1));
        params.delete('variant');
        const appendParams = params.toString();
        params = appendParams ? '&' + appendParams : '';
        window.history.replaceState(
          { vid: newValue.id },
          document.title,
          `${getProductUrl(this.collection, this.product, newValue)}${params}`
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .product-form {
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    .margin-top {
      margin-top: 15px;
      &:last-child {
        margin-top: 10px;
      }
    }

    &__left {
      width: 80%;
      margin: 0 auto;
      @include mobile-tablet {
        width: 100%;
      }
    }

    &__logo {
      height: 28px;
      width: auto;
    }

    &__variant-option-sets {
      position: relative;
    }

    &--logo-active  {
      @include mobile-only {
        .product-form__quantity-wrapper {
          width: 164px;
          order: 1;
        }
      }
    }

    &__desktop-top &__price-container,
    &__desktop-top .pdp__sku {
      margin-bottom: 16px;
    }

    &__magnet-container {
      display: flex;
      flex-direction: column;
      max-height: 234px;
      position: relative; // necessary to prevent browser auto-scrolling on when a variant is focused!
      overflow-y: scroll;

      @media screen and (min-width: 575px) {
        flex-direction: row;
        flex-wrap: wrap;
      }
    }

    &__magnet-container .pb-magnet {
      width: calc(100% - 2px);
      margin: 4px 0;

      @media screen and (min-width: 575px) {
        margin: 4px 6px;
        width: calc(50% - 12px);
      }
    }

    &__scroll-more-arrow {
      fill: $color-brand-primary;
      transform: rotate(-90deg);
      position: absolute;
      right: -14px;
      bottom: 36px;
    }

    .pdp__sku, .pdp__stock {
      display: inline-block;
    }

    &__desktop-top &__price-container {
      display: flex;
      align-items: center;
    }

    &__desktop-top &__description {
      margin-bottom: 24px;
    }

    &__to-description {
      display: inline-block;
      font-weight: 400;
      line-height: 22px;
      vertical-align: bottom;
    }

    &__includes {
      display: block;
      margin-top: 8px;
      line-height: 22px;

      * {
        font-size: rem(12);
      }

      strong {
        font-weight: 500;
        color: $color-black;
      }

      span {
        color: $color-off-black;
      }
    }

    &__quantity-wrapper {
      display: none; // inline-flex
      align-items: center;
    }

    &__quantity-wrapper label {
      margin-right: 8px;
      letter-spacing: normal;
    }

    &__quantity-wrapper { // IE
      width: 100%;
    }

    /deep/ &__quantity {
      height: 45px;
      border: 1px solid $color-light-grey;
      border-radius: 2px;
      background: $color-white;
      align-items: center;
      transition: border 300ms ease-in-out;

      .quantity__label {
        width: 32px;

        @include tablet-up {
          width: 36px;
        }
      }

      .quantity__change {
        margin: 0 8px;

        &:not(:hover) {
          box-shadow: none;
        }
      }
    }

    /deep/ &__quantity--error {
      border: 1px solid $color-util-error !important;
    }

    &__optional-messaging {
      padding: 8px 0;
      color: $color-util-sale;

      /deep/ * {
        color: inherit;
      }

      /deep/ p {
        margin: 0 !important;
      }
    }

    &__atc.button:not(.button--state-loading):disabled,
    &__atc.button:not(.button--state-error):disabled,
    &__atc.button:not(.button--state-success):disabled {
      background: $color-lightest-grey;
      border-color: $color-lightest-grey;

      /deep/ .button__content {
        color: $color-off-black;
      }
    }

    &__feature-icons {
      display: flex;
      justify-content: space-between;
      border-top: 1px solid $color-light-grey;
      padding-top: 20px;
      margin-top: 25px;
      @include mobile-only {
        border-top: 0;
        margin-top: 0;
        padding-left: 8px;
        padding-right: 8px;
      }
    }

    &__icon-set {
      padding: 0;
      margin: 0;
    }

    &__icon-set-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }

    &__icon-set img {
      width: 30px;
      margin: 0 0 10px 0;
      display: inline-block;
      vertical-align: middle;
    }

    .swatches-static {
      margin-bottom: 0;
    }

    .swatches-static:last-child {
      margin-bottom: -8px;

      @include tablet-up {
        margin-bottom: -14px;
      }
    }

    .swatches-static .swatches-static__swatch:disabled {
      cursor: default !important;
      position: relative;
    }

    .swatches-static .swatches-static__swatch:disabled * {
      opacity: .15;
    }

    .swatches-static .swatches-static__swatch:disabled::after {
      content: '';
      width: calc(100% + 6px);
      height: 1px;
      background: $color-grey;
      position: absolute;
      top: 50%;
      left: -3px;
      transform: rotate(-45deg);
      transform-origin: center;
    }

    .pdp--flex-row.product-form__share-desktop {
      display: none;
    }

    .pdp--flex-row.product-form__share-mobile {
      display: flex;
    }

    &__share-mobile > * {
      max-width: 50%;
    }

    &__share-desktop span {
      font-size: rem(12);
      letter-spacing: .75px;
      text-transform: uppercase;
      font-weight: 500;
      align-items: center;
    }

    &__share-mobile span {
      font-size: rem(12);
      letter-spacing: .75px;
      text-transform: uppercase;
      font-weight: 400;
      align-items: center;
    }

    &__share-desktop *,
    &__share-mobile * {
      vertical-align: middle;
    }

    &__share-desktop:first-child,
    &__share-mobile:first-child {
      margin-right: 8px;
    }

    .spr-starrating {
      padding: 0;
    }

    &__sku-mobile.pdp__sku {
      margin: 0;
    }

    &__atc {
      height: 50px;
      line-height: 50px;
    }

    &__description-mobile {
      padding-top: 16px;
      border-top: 1px solid $color-grey;
    }

    &__save-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;
      position: relative;

      button {
        padding: 16px 0;
      }

      button, button * {
        color: $color-brand-primary;
        fill: $color-brand-primary;
      }

      button .icon {
        margin-right: 8px;
        vertical-align: middle;
      }

      button + button {
        margin-left: 16px;
      }
    }
  }

  /deep/ .option-set {
    position: relative;
    font-size: 0;
    padding: 0;

    &__top {
      margin: 0 0 20px;
      @include mobile-only {
        margin: 0 0 15px;
      }
      span {
        color: $color-black;
        font-size: rem(12);
      }
      .option-set__value {
        padding-left: 3px;
      }
      .option-set__label {
        font-weight: 500;
      }
    }

    label {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: 1px solid $color-lightest-grey;
      border-radius: 1px;
      font-weight: 500;
      width: 55px;
      height: 55px;
      color: $color-black;
      margin-right: 20px;
      margin-bottom: 20px;
      font-family: $font-family-secondary;
      font-size: rem(13);
      position: relative;

      &:hover {
        border-color: $color-dark-grey;
      }

      @include mobile-only {
        width: 43px;
        height: 43px;
      }

      &:last-child {
        margin-right: 0;
      }
      &.disabled {
        background-color: $color-brand-tertiary !important;
        border: 0;
        color: $color-grey;
        text-decoration: line-through;
      }
    }

    input:not(:disabled) + label {
      cursor: pointer;
    }

    input {
      appearance: none;
      display: none;
    }

    input:not(:disabled) + label:hover,
    input:not(:disabled) + label:focus,
    input:not(:disabled):focus + label {
      background: $color-brand-secondary;
      // outline: none !important;
    }

    input:checked + label {
      background: $color-brand-secondary;
      border-color: $color-black;
    }

    input:checked + label:hover {
      cursor: default;
      opacity: .7;
    }

    input:disabled + label {
      background-color: $color-white;
      color: $color-off-white;
      border-color: $color-off-white;
    }
  }

  @include tablet-up {
    .product-form {
      margin-right: auto;
      font-size: 0;
      vertical-align: top;
      padding-left: 40px;
      width: 50%;
      left: 0;
      float: right; // so the accordions can be directly under the image gallery in ~tablet widths

      &__top {
        display: block !important;
      }

      &__max-width-container {
        max-width: 440px;
      }

      &__desktop-top &__price-container {
        display: flex;
        align-items: center;
        justify-items: flex-start;
      }

      &__price {
        margin-right: 16px;
      }

      .swatches-static {
        margin-bottom: 10px;
      }

      .swatches-static:last-child {
        margin-bottom: 0;
      }

      &__price-compare {
        margin-right: 7%; // 40px @ containers max-width
        color: $color-compare-price;
      }

      .pdp__sku, .pdp__stock {
        margin-bottom: 16px;
      }

      /deep/ &__quantity-wrapper label {
        position: static;
        display: inline-block;
        transform: none;
      }

      &__description-mobile {
        display: none;
      }

      &__mobile {
        padding-left: 0 !important;
        padding-right: 0 !important;
        position: relative;
        top: 1px;
      }

      &__price-compare,
      &__price {
        display: inline-block;
        position: relative;
      }
    }
  }
  @include tablet-up {
    .product-form {
      top: 95px;
      position: -webkit-sticky;
      position: -moz-sticky;
      position: -ms-sticky;
      position: -o-sticky;
      position: sticky;
      overflow-y: scroll;
      height: calc(100vh - 95px);
    }
  }

  @include desktop-up {
    .product-form {
      width: 42%;
    }
  }

  .byk-callout {
    padding-top: 16px;
    border-top: 1px solid $color-grey;

    &__heading {
      text-align: center;
      font-family: $font-family-primary;
      text-transform: inherit;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 16px;
    }

    &__main {
      padding: 8px;
      border: 1px solid $color-light-grey;
      font-size: 0;
      width: 100%;
      border-radius: 4px;
    }

    &__main > * {
      display: inline-block;
      vertical-align: top;
    }

    &__main img {
      width: 88px;
      margin-right: 16px;
    }

    &__main div {
      width: calc(100% - 88px - 16px);
    }

    &__main p {
      margin-bottom: 8px;
      line-height: 20px;
    }

    @include desktop-up {
      border-top: none;
      padding-top: 8px;

      &__heading {
        font-size: 18px;
        line-height: 22px;
        text-align: left;
      }

      &__main img {
        width: 112px;
        margin-right: 24px;
      }

      &__main p {
        line-height: 22px;
        font-size: rem(16);
        max-width: 95%;
      }

      &__main div {
        width: calc(100% - 112px - 24px);
      }
    }
  }
  .pftm__summary {
    @include mobile-only {
      margin-top: 20px;
    }
  }
</style>
